import * as React from 'react';
import { Row, Col, Form } from "antd";
import { TextView } from 'src/core/ui/text.view';
import { ZuluIcon } from 'src/app/shared/icon';

interface PaysafeState {
	processing: boolean;
	errors: string;
	paysafe?: any;
}

export default class PaysafeGateway extends React.Component<GatewayProps, PaysafeState> {
	constructor(props) {
		super(props);

		this.state = {
			processing: true,
			errors: '',
		};
	}

	public render() {
		const { errors: propsErrors, payComponent } = this.props;
		const { errors } = this.state;

		return (
			<div className="payment-container">

				<h2>Paysafe</h2>

				{propsErrors && propsErrors.message && <h4 style={{ color: 'red' }}>{propsErrors.message}</h4>}

				{errors && <h4 style={{ color: 'red' }}>{errors}</h4>}

				<form id="paysafe-form" onSubmit={this.handleSubmit}>
					<div id="paysafe-container">
						<Row>
							<Col xs={24}>
								<Form.Item label="CARD NUMBER" required={true}>
									<span className="ant-input-group-wrapper">
										<span className="ant-input-wrapper ant-input-group">
											<div className="ant-input" id="cardNumber" />
											<span className="ant-input-group-addon">
												<ZuluIcon type="credit-card" />
											</span>
										</span>
									</span>
								</Form.Item>
							</Col>
							<Col xs={24}>
								<Form.Item label="EXP DATE" required={true}>
									<span className="ant-input-group-wrapper">
										<span className="ant-input-wrapper ant-input-group">
											<div className="ant-input" id="cardExpiry" />
											<span className="ant-input-group-addon">
												<ZuluIcon type="calendar" />
											</span>
										</span>
									</span>
								</Form.Item>
							</Col>
							<Col xs={24}>
								<Form.Item label="CV CODE" required={true}>
									<span className="ant-input-group-wrapper">
										<span className="ant-input-wrapper ant-input-group">
											<div className="ant-input" id="cardCVC" />
											<span className="ant-input-group-addon">
												<ZuluIcon type="unlock" />
											</span>
										</span>
									</span>
								</Form.Item>
							</Col>
						</Row>
					</div>

					<div id="submit-container">
						{payComponent}
					</div>

				</form>
			</div>
		);
	}

	// Decode string and prevent XSS vulnerabilities thanks to the use of DOMParser.
	private htmlDecode = (input) => {
		var doc = new DOMParser().parseFromString(input, "text/html");
		return doc.documentElement.textContent;
	}

	private handleSubmit = (e) => {
		e.preventDefault();
		console.log('paysafe custom onSubmit');

		const { paysafe } = this.state;
		const { cardHolder, gateway, onTokenReceive } = this.props;

		paysafe.tokenize({
			vault: {
				holderName: this.htmlDecode(cardHolder),
			}
		}, (instance, error, result) => {
			if (error) {
				// An error occurred while tokenizing the card details
				console.log(error);
				this.setState({ errors: error.displayMessage });
			} else {
				// Print the generated card token
				console.log(result.token);
				onTokenReceive(result.token, gateway.paymentGatewayName, { description: 'Test Description' })
			}
		});
	}

	// https://developer.paysafe.com/en/sdks/paysafejs/setup/
	private paysafeSetup = async () => {
		const { gateway } = this.props;

		// Base64-encoded version the Single-Use Token API key.
		// Create the key below by concatenating the API username and password
		// separated by a colon and Base 64 encoding the result
		const apiKey = gateway.additionalInfo.paysafeClientApiKey;

		const options = {
			// select the Paysafe test / live environment
			environment: gateway.additionalInfo.paysafeEnvironment,

			// set the CSS selectors to identify the payment field divs above
			// set the placeholder text to display in these fields
			fields: {
				cardNumber: {
					selector: "#cardNumber",
					placeholder: "Card number",
					separator: " "
				},
				expiryDate: {
					selector: "#cardExpiry",
					placeholder: "Expiry date"
				},
				cvv: {
					selector: "#cardCVC",
					placeholder: "CVV",
					optional: false
				}
			}
		};

		// initalize the hosted iframes using the SDK setup function
		window.paysafe.fields.setup(apiKey, options, (instance, error) => {
			if (error) {

				// Paysafe initialization failed
				this.setState({ errors: error.displayMessage }, () => {
					console.log(error);
					this.setState({ processing: false });
				});

			} else {

				this.setState({ paysafe: instance }, () => {
					// Paysafe initialization completed
					this.setState({ processing: false });
				});
			}
		});
	}

	public componentDidMount() {
		const { gateway, onMount } = this.props;
		onMount(this.paysafeSetup, [gateway.additionalInfo.paysafeScriptUrl]);
	}
}



// WEBPACK FOOTER //
// ./src/app/accounting/payment-gateway/parts/paysafe.tsx